import { UIMatch } from 'react-router-dom';
import { create } from 'zustand';

import { BreadcrumbConfig } from 'support/types/breadcrumbs';

type BreadcrumbsState = {
  breadcrumbs: Array<BreadcrumbConfig>;
  setBreadcrumb: (breadcrumb: BreadcrumbConfig, index: number) => void;
  clearBreadcrumbs: () => void;
  previousMatches: Array<UIMatch>;
  setPreviousMatches: (matches: Array<UIMatch>) => void;
};

export const useBreadcrumbsStore = create<BreadcrumbsState>()((set) => ({
  breadcrumbs: [],
  matchesCache: new Map(),
  previousMatches: [],
  setBreadcrumb: (breadcrumb, index) =>
    set((state) => {
      const newBreadcrumbs = [...state.breadcrumbs];
      newBreadcrumbs[index] = breadcrumb;
      return { breadcrumbs: newBreadcrumbs };
    }),
  clearBreadcrumbs: () => set({ breadcrumbs: [] }),
  setPreviousMatches: (matches) =>
    set(() => ({
      previousMatches: matches,
    })),
}));

export const getPreviousMatches = () => useBreadcrumbsStore.getState().previousMatches;
export const setPreviousMatches = (matches: Array<UIMatch>) =>
  useBreadcrumbsStore.getState().setPreviousMatches(matches);

export const clearBreadcrumbs = () => useBreadcrumbsStore.getState().clearBreadcrumbs();
export const setBreadcrumb = (breadcrumb: BreadcrumbConfig, index: number) =>
  useBreadcrumbsStore.getState().setBreadcrumb(breadcrumb, index);
